import React, { createContext, useContext, useCallback } from 'react';
import { toast } from 'react-toastify';
import api from '../services/api';

const EducationContext = createContext();

export const EducationProvider = ({ children }) => {
  const accessToken = localStorage.getItem('accessToken');


  const listSchoolUnits = useCallback(async (params = {}) => {
    try {
      const response = await api.get('auxiliaries/schoolunit/', {
        headers: { Authorization: `Bearer ${accessToken}` },
        params,
      });

      return response.data;
    } catch (error) {
      console.error('Erro ao buscar unidades escolares:', error);
      toast.error('Erro ao buscar unidades escolares');
    }
  }, [accessToken]);

  const listScholarities = useCallback(async () => {
    try {
      const response = await api.get('auxiliaries/scholarity/', {
        headers: { Authorization: `Bearer ${accessToken}` }
      });

      return response.data;
    } catch (error) {
      console.error('Erro ao buscar escolaridade:', error);
      return { results: [] };
    }
  }, [accessToken]);

  const listReceptioneducational = useCallback(async (params = {}) => {
    try {
      const response = await api.get('internals/receptioneducational/', {
        headers: { Authorization: `Bearer ${accessToken}` },
        params,
      });

      return response.data;
    } catch (error) {
      console.error('Erro ao buscar internal educação:', error);
      return { results: [] };
    }
  }, [accessToken]);

  const createReceptioneducational = useCallback(async (data) => {
    try {
      const response = await api.post('internals/receptioneducational/', data, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      toast.success('Recepção de educação cadastrada com sucesso!');
      return response.data;
    } catch (error) {
      console.error('Erro ao criar recepção de educação:', error);
      toast.error('Erro ao criar recepção de educação');
    }
  }, [accessToken]);

  const updateReceptioneducational = useCallback(async (id, data) => {
    try {
      const response = await api.patch(`internals/receptioneducational/${id}/`, data, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      toast.success('Dados de educação atualizados com sucesso!');
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar dados de educação:', error);
      toast.error('Erro ao atualizar dados de educação');
    }
  }, [accessToken]);

  const listInternalEducation = useCallback(async (params = {}) => {
    try {
      const response = await api.get('internals/internaleducation/', {
        headers: { Authorization: `Bearer ${accessToken}` },
        params,
      });

      return response.data;
    } catch (error) {
      console.error('Erro ao buscar internal educação:', error);
      return { results: [] };
    }
  }, [accessToken]);

  const createInternalEducation = useCallback(async (data) => {
    try {
      const response = await api.post('internals/internaleducation/', data, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      toast.success('Dados de educação cadastrados com sucesso!');
      return response.data;
    } catch (error) {
      console.error('Erro ao criar dados de educação:', error);
      toast.error('Erro ao criar dados de educação');
    }
  }, [accessToken]);

  const updateInternalEducation = useCallback(async (id, data) => {
    try {
      const response = await api.patch(`internals/internaleducation/${id}/`, data, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      toast.success('Dados de educação atualizados com sucesso!');
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar dados de educação:', error);
      toast.error('Erro ao atualizar dados de educação');
    }
  }, [accessToken]);

  const createEducationEvolution = useCallback(async (data) => {
    try {
      const response = await api.post('internals/educationalevolution/', data, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      toast.success('Evolução educacional adicionada com sucesso!');
      return response.data;
    } catch (error) {
      console.error('Erro ao adicionar evolução educacional:', error);
      toast.error('Erro ao adicionar evolução educacional');
    }
  }, [accessToken]);

  const listEducationEvolution = useCallback(async (params = {}) => {
    try {
      const response = await api.get('internals/educationalevolution/', {
        headers: { Authorization: `Bearer ${accessToken}` },
        params,
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar evoluções educacionais:', error);
      return [];
    }
  }, [accessToken]);

  const listClasses = useCallback(async (params = {}) => {
    try {
      const response = await api.get('internals/class/', {
        headers: { Authorization: `Bearer ${accessToken}` },
        params
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar turmas:', error);
      toast.error('Erro ao buscar turmas');
    }
  }, [accessToken]);

  const createClass = useCallback(async (data) => {
    try {
      const response = await api.post('internals/class/', data, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      toast.success('Turma criada com sucesso!');
      return response.data;
    } catch (error) {
      console.error('Erro ao criar turma:', error);
      toast.error('Erro ao criar turma');
    }
  }, [accessToken]);

  const listEnrollments = useCallback(async (params = {}) => {
    try {
      const response = await api.get('internals/enroll/', {
        headers: { Authorization: `Bearer ${accessToken}` },
        params,
      });

      return response.data;
    } catch (error) {
      console.error('Erro ao buscar matrículas:', error);
      toast.error('Erro ao buscar matrículas');
    }
  }, [accessToken]);

  const createEnrollment = useCallback(async (data) => {
    try {
      const response = await api.post('internals/enroll/', data, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      toast.success('Matrícula criada com sucesso!');
      return response.data;
    } catch (error) {
      console.error('Erro ao criar matrícula:', error);
      toast.error('Erro ao criar matrícula');
    }
  }, [accessToken]);

  const updateEnrollment = useCallback(async (id, data) => {
    try {
      const response = await api.patch(`internals/enroll/${id}/`, data, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      toast.success('Matrícula atualizada com sucesso!');
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar matrícula:', error);
      toast.error('Erro ao atualizar matrícula');
    }
  }, [accessToken]);

  const listSubjects = useCallback(async (params = {}) => {
    try {
      const response = await api.get('internals/subject/', {
        headers: { Authorization: `Bearer ${accessToken}` },
        params,
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar disciplinas:', error);
      toast.error('Erro ao buscar disciplinas');
    }
  }, [accessToken]);


  const createSubject = useCallback(async (data) => {
    try {
      const response = await api.post('internals/subject/', data, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      toast.success('Disciplina cadastrado com sucesso!');
      return response.data;
    } catch (error) {
      console.error('Erro ao cadastrar disciplina:', error);
      toast.error('Erro ao cadastrar disciplina');
    }
  }, [accessToken]);

  const listTypeSubjects = useCallback(async () => {
    try {
      const response = await api.get('auxiliaries/typesubject/', {
        headers: { Authorization: `Bearer ${accessToken}` }
      });

      return response.data;
    } catch (error) {
      console.error('Erro ao buscar tipos de disciplina:', error);
      toast.error('Erro ao buscar tipos de disciplina');
    }
  }, [accessToken]);

  const createTypeSubject = useCallback(async (data) => {
    try {
      const response = await api.post('auxiliaries/typesubject/', data, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      toast.success('Tipo de Disciplina cadastrado com sucesso!');
      return response.data;
    } catch (error) {
      console.error('Erro ao cadastrar tipos de disciplina:', error);
      toast.error('Erro ao cadastrar tipos de disciplina');
    }
  }, [accessToken]);

  const listTeachers = useCallback(async (params = {}) => {
    try {
      const response = await api.get('auxiliaries/teacher/', {
        headers: { Authorization: `Bearer ${accessToken}` },
        params,
      });

      return response.data;
    } catch (error) {
      console.error('Erro ao buscar professores:', error);
      toast.error('Erro ao buscar professores');
    }
  }, [accessToken]);

  const createTeacher = useCallback(async (data) => {
    try {
      const response = await api.post('auxiliaries/teacher/', data, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      toast.success('Professor cadastrado com sucesso!');
      return response.data;
    } catch (error) {
      console.error('Erro ao cadastrar professor:', error);
      toast.error('Erro ao cadastrar professor');
    }
  }, [accessToken]);

  const listFrequencies = useCallback(async (params = {}) => {
    try {
      const response = await api.get('internals/frequency/', {
        headers: { Authorization: `Bearer ${accessToken}` },
        params,
      });

      return response.data;
    } catch (error) {
      console.error('Erro ao buscar frequências:', error);
      toast.error('Erro ao buscar frequências');
    }
  }, [accessToken]);

  const createFrequency = useCallback(async (data) => {
    try {
      const response = await api.post('internals/frequency/', data, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      toast.success('Frequência registrada com sucesso!');
      return response.data;
    } catch (error) {
      console.error('Erro ao registrar frequência:', error);
      toast.error('Erro ao registrar frequência');
    }
  }, [accessToken]);

  const updateFrequency = useCallback(async (id, data) => {
    try {
      const response = await api.patch(`internals/frequency/${id}/`, data, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      toast.success('Frequência atualizada com sucesso!');
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar frequência:', error);
      toast.error('Erro ao atualizar frequência');
    }
  }, [accessToken]);

  const listScores = useCallback(async (params = {}) => {
    try {
      const response = await api.get('internals/score/', {
        headers: { Authorization: `Bearer ${accessToken}` },
        params,
      });

      return response.data;
    } catch (error) {
      console.error('Erro ao buscar notas:', error);
      toast.error('Erro ao buscar notas');
    }
  }, [accessToken]);

  const createScore = useCallback(async (data) => {
    try {
      const response = await api.post('internals/score/', data, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      toast.success('Nota registrada com sucesso!');
      return response.data;
    } catch (error) {
      console.error('Erro ao registrar nota:', error);
      toast.error('Erro ao registrar nota');
    }
  }, [accessToken]);

  const updateScore = useCallback(async (id, data) => {
    try {
      const response = await api.patch(`internals/score/${id}/`, data, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      toast.success('Nota atualizada com sucesso!');
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar nota:', error);
      toast.error('Erro ao atualizar nota');
    }
  }, [accessToken]);

  const listReading = useCallback(async (params = {}) => {
    try {
      const response = await api.get('internals/reading/', {
        headers: { Authorization: `Bearer ${accessToken}` },
        params,
      });

      return response.data;
    } catch (error) {
      console.error('Erro ao buscar leituras livres:', error);
      return { results: [] };
    }
  }, [accessToken]);

  const createReading = useCallback(async (data) => {
    try {
      const response = await api.post('internals/reading/', data, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      toast.success('Leitura registrada com sucesso!');
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Erro desconhecido';
      toast.error(`Erro ao registrar leitura: ${errorMessage}`);
    }
  }, [accessToken]);

  const listFinalResults = useCallback(async (params = {}) => {
    try {
      const response = await api.get('internals/finalresult/', {
        headers: { Authorization: `Bearer ${accessToken}` },
        params,
      });

      return response.data;
    } catch (error) {
      console.error('Erro ao buscar resultados finais:', error);
      toast.error('Erro ao buscar resultados finais');
      return { results: [] };
    }
  }, [accessToken]);

  const createFinalResult = useCallback(async (data) => {
    try {
      const response = await api.post('internals/finalresult/', data, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      toast.success('Resultado final registrado!');
      return response.data;
    } catch (error) {
      console.error('Erro ao registrar resultado final:', error);
      const msg = error.response?.data?.message || 'Erro ao registrar resultado final';
      toast.error(msg);
    }
  }, [accessToken]);

  const updateFinalResult = useCallback(async (id, data) => {
    try {
      const response = await api.patch(`internals/finalresult/${id}/`, data, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      toast.success('Resultado final atualizado!');
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar resultado final:', error);
      const msg = error.response?.data?.message || 'Erro ao atualizar resultado final';
      toast.error(msg);
    }
  }, [accessToken]);

  const listCourses = useCallback(async (params = {}) => {
    try {
      const response = await api.get('auxiliaries/course/', {
        headers: { Authorization: `Bearer ${accessToken}` },
        params,
      });

      return response.data;
    } catch (error) {
      console.error('Erro ao buscar cursos:', error);
      toast.error('Erro ao buscar cursos');
    }
  }, [accessToken]);

  const createCourse = useCallback(async (data) => {
    try {
      const response = await api.post('auxiliaries/course/', data, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      toast.success('Curso cadastrado com sucesso!');
      return response.data;
    } catch (error) {
      console.error('Erro ao cadastrar curso:', error);
      toast.error('Erro ao cadastrar curso');
    }
  }, [accessToken]);


  // Listar tipos de curso
  const listTypeCourses = useCallback(async () => {
    try {
      const response = await api.get('auxiliaries/typecourse/', {
        headers: { Authorization: `Bearer ${accessToken}` }
      });

      return response.data;
    } catch (error) {
      console.error('Erro ao buscar tipos de curso:', error);
      toast.error('Erro ao buscar tipos de curso');
    }
  }, [accessToken]);

  const listLiteracyIbraema = useCallback(async (params = {}) => {
    try {
      const response = await api.get('internals/literacy/', {
        headers: { Authorization: `Bearer ${accessToken}` },
        params
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar alfabetização Ibraema:', error);
      toast.error('Erro ao buscar alfabetização Ibraema');
      return { results: [] };
    }
  }, [accessToken]);

  const createLiteracyIbraema = useCallback(async (data) => {
    try {
      const response = await api.post('internals/literacy/', data, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      toast.success('Alfabetização Ibraema cadastrada com sucesso!');
      return response.data;
    } catch (error) {
      console.error('Erro ao criar alfabetização Ibraema:', error);
      toast.error('Erro ao cadastrar alfabetização Ibraema');
    }
  }, [accessToken]);

  const updateLiteracyIbraema = useCallback(async (id, data) => {
    try {
      const response = await api.patch(`internals/literacy/${id}/`, data, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      toast.success('Alfabetização Ibraema atualizada com sucesso!');
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar alfabetização Ibraema:', error);
      toast.error('Erro ao atualizar alfabetização Ibraema');
    }
  }, [accessToken]);


  return (
    <EducationContext.Provider value={{
      listSchoolUnits,
      listScholarities,
      listReceptioneducational,
      listInternalEducation,
      listClasses,
      createClass,
      listEnrollments,
      createEnrollment,
      updateEnrollment,
      listSubjects,
      createSubject,
      createTypeSubject,
      listTypeSubjects,
      listTeachers,
      createTeacher,
      listFrequencies,
      createFrequency,
      updateFrequency,
      listScores,
      createReceptioneducational,
      createInternalEducation,
      updateInternalEducation,
      updateReceptioneducational,
      createEducationEvolution,
      listEducationEvolution,
      listReading,
      createReading,
      listCourses,
      createCourse,
      listTypeCourses,
      listFinalResults,
      createFinalResult,
      updateFinalResult,
      listLiteracyIbraema,
      createLiteracyIbraema,
      updateLiteracyIbraema,
      createScore,
      updateScore,
    }}>
      {children}
    </EducationContext.Provider>
  );
};

export const useEducation = () => useContext(EducationContext);
